import React from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';
import { userService } from '../../_services/user.service';
import moment, { relativeTimeRounding } from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import loader from '../../components/css/dark/img/loader.gif';


class TransitionPopup extends React.Component {

    constructor(props) {
        super(props);

        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 10);
        var enddate = new Date();

        this.state = {
            startDate: new moment(startdate).format("MM/DD/YYYY"),
            endDate: new moment(enddate).format("MM/DD/YYYY"),
            whname: this.props.wholesaler_name,
            wh_id: this.props.wholeSaler_id,
            unique_ObjectId: this.props.unique_ObjectId,
            RawTool: null,
            Processor: [
                { id: 1, value: "1", isChecked: true, pname: "CRX" },
                { id: 2, value: "2", isChecked: true, pname: "HRX" },
                { id: 3, value: "3", isChecked: true, pname: "HDX" },
                { id: 4, value: "4", isChecked: true, pname: "GH" }
            ],
            loading: false,
            error: ''
        }

        this.getComponent = this.getComponent.bind(this);
        this.handleCalendar = this.handleCalendar.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleCheckChieldElement = this.handleCheckChieldElement.bind(this);
        this.handlebuttonClick = this.handlebuttonClick.bind(this);

        this.GetRawTool(this.state.whname, this.state.wh_id, '');
    }

    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        let today = new moment().format("MM/DD/YYYY");
        
        // Prevent selecting dates after today
        if (moment(changedEndDate).isAfter(moment(), 'day')) {
            $('.ErrorMessage').html('Cannot select dates after today');
            return;
        }
        
        try {
            $('.first').val(changedStartDate);
            $('.second').val(changedEndDate);
            this.setState({ startDate: changedStartDate, endDate: changedEndDate });
            $('.ErrorMessage').html(''); // Clear any previous error
        }
        catch (error) {
        }

    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        // this.GetRawTool(this.state.whname, '');
        $('.readonly-attr').attr('readonly', 'readonly');
    }
    handleChangeDate(e) {
        this.props.handleChangeDateNew(e);
    }
    getComponent(event) {
        return <sheet />;
    }
    handleCheckChieldElement = (event) => {
        let p = this.state.Processor
        p.forEach(p1 => {
            if (p1.value === event.target.value)
                p1.isChecked = event.target.checked
        })
        this.setState({ Processor: p })
        let checkeditem = this.state.Processor.filter((item) => {
            return item.isChecked == true;
        });
        if (checkeditem.length == 0) {
            $('.ErrorMessage').html('Please select at least one data source!');
        }
        else {
            $('.ErrorMessage').html('');
        }
    }
    handlebuttonClick(e) {
        this.setState({ loading: true, error: '' });
        $('.ErrorMessage').html('');
        let plist = '';
        var datefrom = $('.first').val();
        var dateto = $('.second').val();
        var DisName = $('#DisName').val();
        var msDiff = new Date(dateto).getTime() - new Date(datefrom).getTime();
        var DateRange = Math.floor(msDiff / (1000 * 60 * 60 * 24));

        let checkeditem = this.state.Processor.filter((item) => {
            return item.isChecked == true;
        });
        if (checkeditem.length == 0) {
            e.preventDefault();
            $('.ErrorMessage').html('Please select at least one data source');
            return false;
        }
        if (DateRange > 31) {
            e.preventDefault();
            $('.ErrorMessage').html('Date range must be upto 31 days');
            return false;
        }

        let p = this.state.Processor;
        p.forEach(p1 => {
            if (p1.isChecked == true) {
                if (plist == '') {
                    plist = p1.value;
                }
                else {
                    plist = plist + ',' + p1.value;
                }
            }
        })
        //this.SaveRawTool(this.state.whname, this.state.wh_id, DisName, plist, datefrom, dateto);
        this.GetRawTransactionStatus(this.state.whname, this.state.unique_ObjectId, DisName, plist, datefrom, dateto, e, this.state.unique_ObjectId);
        //this.DownloadRawData(this.state.whname, this.state.wh_id, DisName, plist, datefrom, dateto, e, this.state.unique_ObjectId);
        e.preventDefault();
    }
    GetRawTool(whname, wh_id, mname) {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ whname, wh_id, mname })
        };
        return fetch(`/api/ws/RawTransactionTool`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        this.setState({ RawTool: apidata });
                    }
                }
                catch (error) {
                }
            });
    }
    DownloadRawData(whname, wh_id, disname, plist, datefrom, dateto, e, unique_ObjectId) {
        try {
            this.setState({ loading: false, error: '' });
            let Origin_Location = window.location.protocol + "//" + window.location.host;
            window.open(
                Origin_Location + '/report/rawtransaction?wname=' + whname + '&wh_id=' + unique_ObjectId + '&dname=' + disname + '&pcn=' + plist + '&df=' + datefrom + '&dt=' + dateto,
                '_blank'
            );
            e.preventDefault();
        }
        catch (error) { }
    }
    GetRawTransactionStatus(wname, wh_id, dname, pcn, df, dt, e, unique_ObjectId) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ wname, wh_id, dname, pcn, df, dt })
            };
            return fetch(`/api/ws/rawtransactionstatus`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].maxValue <= 0) {
                                this.setState({ loading: false, error: apidata[0].data });
                            }
                            else {
                                this.DownloadRawData(wname, wh_id, dname, pcn, df, dt, e, unique_ObjectId);
                            }
                        }
                        else {
                            this.setState({ loading: false, error: 'Error! Please try later.' });
                        }
                    }
                    catch (error) {
                        this.setState({ loading: false, error: 'Error! Please try later.' });
                    }
                });
        }
        catch (error) {
            this.setState({ loading: false, error: 'Error! Please try later.' });
        }
    }
    SaveRawTool(whname, wh_id, disname, plist, datefrom, dateto) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ whname, wh_id, disname, plist, datefrom, dateto })
        };
        return fetch(`/api/ws/SaveRawDataRequest`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        if (apidata[0].statusMessage == 'Success') {
                            $('.ErrorMessage').html('Success!');
                        }
                        else {
                            $('.ErrorMessage').html('Error!');
                        }
                    }
                    else {
                        $('.ErrorMessage').html('Error!');
                    }
                }
                catch (error) {
                    $('.ErrorMessage').html('Error!');
                }
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    render() {
        const { loading, error, elements } = this.state;
        return (
            <div className='popup mfp-zoom-in TransitionsPopup generate'>
                <div className='popup_inner transitionPopup'>

                    <h1>{this.props.text}<button onClick={this.props.closeRawTransactionPopup}>X</button></h1>

                    <div className="TransitionReport">
                        <form className="WhCommissionPopup">

                            <div className="source">
                                <div className="left-side">
                                    <div className="selectSection"><label>Select a Distributor</label><span className="down-arrow"></span>
                                        <select className="form-Control" id="DisName">
                                            <option value="All">All</option>
                                            {/*{
                                                this.state.RawTool != null ?
                                                    this.state.RawTool[0]["distributor"].map((obj, index) => {
                                                        if (index == 0) {
                                                            return <option value={obj}>{obj}</option>
                                                        }
                                                        else {
                                                            return false;
                                                        }
                                                    }) : null
                                            }*/}
                                        </select>
                                    </div>
                                </div>
                                <div className="center-side">
                                    <label>Select Data Source(s)</label>
                                    <div className="checkbox-section theme-checkbox edit-section">
                                        {
                                            this.state.Processor.map((p, index) => {
                                                let _class = "";
                                                if (index == this.state.Processor.length - 1) {
                                                    _class = "last-one";
                                                }
                                                return <div className="same-checkbox">
                                                    <input type="checkbox" name="datasource" id={p.pname} value={p.value} checked={p.isChecked} onClick={this.handleCheckChieldElement} />
                                                    <span class="checkmark"></span>
                                                    <label for={p.pname} class={_class}>{p.pname}</label>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="right-side">
                                    <DateRangePicker 
                                        popperModifiers={{ preventOverflow: { enabled: true, }, }} 
                                        initialSettings={{
                                            startDate: this.state.startDate,
                                            endDate: this.state.endDate,
                                            maxDate: moment().toDate(),
                                            locale: {
                                                format: 'MM/DD/YYYY'
                                            }
                                        }}
                                        onApply={this.handleCalendar}
                                    >
                                        <div className="react-bootstrap-daterangepicker-container">
                                            <div className="react-datepicker_input-container first-one">
                                                <input type="text" className="form-control first readonly-attr" value={this.state.startDate} />
                                            </div>
                                            <div className="react-datepicker_input-container second-one">
                                                <input type="text" className="form-control second readonly-attr" value={this.state.endDate} />
                                            </div>
                                        </div>
                                    </DateRangePicker>
                                </div>
                                <div className="Clearfix"></div>
                                <button className={loading ? "commission-btn btn-theme-color theme-loader raw-btn" : "commission-btn btn-theme-color raw-btn"} onClick={this.handlebuttonClick}>Generate Report</button>
                                <div class="ErrorMessage rawTransaction"></div>
                                {error &&
                                    <div className="ErrorMessage rawTransaction">{error}</div>
                                }
                            </div>
                            {/*<div className="table-container">
                                <h3>Report History</h3>
                                <div className="report-content">
                                    <div className="flex-table header">
                                        <div className="flex-row first">Sr. No.</div>
                                        <div className="flex-row second">Name</div>
                                        <div className="flex-row third">Date Requested</div>
                                        <div className="flex-row fourth">From</div>
                                        <div className="flex-row fifth">To</div>
                                        <div className="flex-row sixth">Action</div>
                                    </div>
                                    <div className="table_body" id="inactive_reps">
                                        <div className="max-height">
                                            {
                                                this.state.RawTool != null ?
                                                    this.state.RawTool[0]["rList"].map((obj, index) => {
                                                        let s1 = '<a href={obj.downloadLink}>Download</a>';
                                                        if (obj.downloadLink.indexOf('http://') !== -1) {
                                                            return <div className="flex-table">
                                                                <div className="flex-row first">1</div>
                                                                <div className="flex-row second">{obj.disName}</div>
                                                                <div className="flex-row third">{obj.requestOn}</div>
                                                                <div className="flex-row fourth">{obj.dateFrom}</div>
                                                                <div className="flex-row fifth">{obj.dateFrom}</div>
                                                                <div className="flex-row sixth"><a href={obj.downloadLink} target="_blank">Download</a></div>
                                                            </div>
                                                        }
                                                        else {
                                                            return <div className="flex-table">
                                                                <div className="flex-row first">1</div>
                                                                <div className="flex-row second">{obj.disName}</div>
                                                                <div className="flex-row third">{obj.requestOn}</div>
                                                                <div className="flex-row fourth">{obj.dateFrom}</div>
                                                                <div className="flex-row fifth">{obj.dateFrom}</div>
                                                                <div className="flex-row sixth">{obj.downloadLink}</div>
                                                            </div>
                                                        }
                                                     
                                                    }) : null
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>*/}
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}


export default TransitionPopup;


